'use strict';

module.exports = [
  ModalSelectorDirective];

function ModalSelectorDirective() {
  return {
    restrict: 'E',
    scope: {
      currentValue: '=?model',
      loadList: '&'
    },
    controllerAs: 'modalSelector',
    bindToController: true,
    controller: function ModalSelector() {

    }
  }
}


// WEBPACK FOOTER //
// ./src/js/domain-directives/ModalSelectorDirective.js